import UpsellCard from './UpsellCard';
import useWheelHorizontalScroll from '../../../hooks/useWheelHorizontalScroll';

const UpgradeSection = ({ label, upgrades, selectedUpgradeId, onSelectUpgrade, originalDisplayPrice, currentBaseId, originalProduct, isTabletScreen }) => {
  if (!upgrades || upgrades.length === 0) return null;

  // Look up the cost of the current base selection on the original product
  const scrollRef = useWheelHorizontalScroll();

  const originalBaseCost = currentBaseId
    ? (originalProduct?.subProducts?.[0]?.subProducts?.find(b => b.id === currentBaseId)?.cost ?? 0)
    : 0;

  return (
    <div className="upsell-section">
      {isTabletScreen ?
        <h3 className="upsell-section__label">{label}</h3> :
        <h2 className="customise-section-header">{label}</h2>
      }
      <div className="upsell-section__scroll-container" ref={scrollRef}>
        {upgrades.map(product => {
          // Look up the cost of the same base on this upgrade product
          const upgradeBaseCost = currentBaseId
            ? (product.subProducts?.[0]?.subProducts?.find(b => b.id === currentBaseId)?.cost ?? 0)
            : 0;

          // When base costs are non-zero they represent the FULL product price
          // (e.g. pizza bases), so compare them directly. When zero, base cost
          // is just a surcharge (or absent) so fall back to displayPrice.
          const priceDifference = (originalBaseCost > 0 && upgradeBaseCost > 0)
            ? upgradeBaseCost - originalBaseCost
            : product.displayPrice - originalDisplayPrice;
          const isSelected = selectedUpgradeId === product.id;

          return (
            <UpsellCard
              key={product.id}
              product={product}
              isSelected={isSelected}
              onSelect={() => onSelectUpgrade(isSelected ? null : product)}
              swapPriceDifference={priceDifference}
              isTabletScreen={isTabletScreen}
            />
          );
        })}
      </div>
    </div>
  );
};

export default UpgradeSection;
